import React, { createContext, useContext } from 'react';
import PropTypes from 'prop-types';
import { FormProvider, useForm } from 'react-hook-form';
import useSearch from '../../hooks/useSearch';

const SearchContext = createContext();

const SearchProvider = ({ initialSearch, children }) => {
  const value = useSearch({ initialSearch });
  return (
    <SearchContext.Provider value={value}>{children}</SearchContext.Provider>
  );
};

const SearchWrapper = ({ initialSearch, children }) => {
  const methods = useForm();
  return (
    <FormProvider {...methods}>
      <SearchProvider initialSearch={initialSearch}>{children}</SearchProvider>
    </FormProvider>
  );
};

const useSearchContext = () => useContext(SearchContext);

const searchProviderPropTypes = {
  children: PropTypes.node.isRequired,
};

SearchProvider.propTypes = searchProviderPropTypes;
SearchWrapper.propTypes = searchProviderPropTypes;
export default SearchWrapper;
export { SearchContext, useSearchContext, searchProviderPropTypes };
